import { InMemoryCache, gql } from '@apollo/client';

const localStateQuery = gql`
  query {
    toasts {
      message
    }
  }
`;

export class LocalApolloCache extends InMemoryCache {
  async populate() {
    this.writeQuery({
      query: localStateQuery,
      data: {
        toasts: [],
      },
    });
  }
}
